import React from 'react';
import Icon from '../../../components/AppIcon';

const LocationInfo = () => {
  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto bg-gradient-to-br from-accent/10 to-primary/10 border border-accent/20 rounded-2xl p-8">
          <div className="flex flex-col md:flex-row items-center space-y-6 md:space-y-0 md:space-x-8">
            <div className="w-20 h-20 rounded-full bg-accent/20 flex items-center justify-center flex-shrink-0">
              <Icon name="Globe" size={40} color="var(--color-accent)" />
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl font-headline font-bold text-foreground mb-2">
                Работаем по всему миру
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                Наши специалисты готовы выехать к вам для проведения консультаций, обучения и внедрения системы. Мы обслуживаем клиентов по всему миру.
              </p>
            </div>
            <a
              href="https://wa.me/77476660065"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 bg-accent text-accent-foreground rounded-lg font-medium hover:bg-accent/90 transition-colors duration-200 flex items-center space-x-2 flex-shrink-0"
            >
              <Icon name="Calendar" size={20} />
              <span>Записаться на визит</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationInfo;